<div class="content-heading">
  <div class="header-container">
    <h3>Código postal</h3>
    <small>Catálogo de códigos postales</small>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-xs-12">
              <div class="row filter-container d-flex align-items-end mb-2">
                <div class="col-md-4">
                  <aph-custom-text label="Código de colonia" placeholder="Ej. 001" [(ngModel)]="neigbhoodCode"
                    (input)="getFiscalConfig()" style="border:none;">
                  </aph-custom-text>
                </div>
                <div class="col-md-4">
                  <aph-custom-text label="Estado" placeholder="Ej. CDMX" [(ngModel)]="stateCode"
                    (input)="getFiscalConfig()" style="border:none;">
                  </aph-custom-text>
                </div>
                <div class="ml-auto mr-3">
                  <aph-custom-buttons type="button" preset="refresh" style="margin-bottom: 8px;" (btnClick)="refresh()"></aph-custom-buttons>
                </div>
              </div>
              <div class="row">
                <app-ceq-table class="col-12" #CeqGrid [gridAdditionalOptions]="gridOptions" [columnDef]="columnDefs"
                  (apiEmitter)="gridEmiter($event)">
                </app-ceq-table>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 mt-3">
              <div class="pagesize-control">
                Tama&ntilde;o de p&aacute;gina:
                <select (change)="onPageSizeChange($event.target.value)">
                  <option *ngFor="let size of PageSizes" [ngValue]="size">{{size}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 mt-3">
              <aph-custom-load-file title="Seleccionar archivo CSV" iconClass="fa fa-file-csv"
                [enableToggleButton]="true" toggleButtonText="Carga Masiva" submitButtonText="Subir archivo"
                (onSubmitClick)="handleFileInput($event)">
              </aph-custom-load-file>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>